
import Button from '@/components/base/Button';

export default function HeroSection() {
  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Video */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover object-center"
          poster="https://public.readdy.ai/ai/img_res/e95793243b7746bdee52843da99b2e4c.jpg"
        >
          <source src="https://readdy.ai/api/search-image?query=Abstract%20spa%20ambience%20video%20with%20soft%20ripples%20in%20clear%20water%20surface%2C%20gentle%20steam%20particles%20floating%20upward%2C%20close-up%20water%20texture%20with%20subtle%20light%20reflections%20dancing%2C%20peaceful%20zen%20atmosphere%2C%20minimalist%20wellness%20background%2C%20soft%20pink%20and%20white%20color%20palette%2C%20serene%20meditation%20setting%2C%20slow%20gentle%20movement%2C%208-12%20seconds%20loop%2C%20no%20people%20visible%2C%20royalty-free%20spa%20video%20content&width=1920&height=1080&seq=spa-hero-video&orientation=landscape&format=mp4" type="video/mp4" />
          {/* Fallback image */}
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20spa%20ambience%20with%20soft%20ripples%20in%20clear%20water%2C%20gentle%20steam%20rising%2C%20peaceful%20zen%20atmosphere%2C%20close-up%20water%20texture%20with%20subtle%20light%20reflections%2C%20minimalist%20wellness%20background%2C%20soft%20pink%20and%20white%20tones%2C%20serene%20meditation%20setting%2C%20no%20people&width=1920&height=1080&seq=spa-video-fallback&orientation=landscape"
            alt="Spa Background"
            className="w-full h-full object-cover object-center"
          />
        </video>
        {/* Pink overlay for text readability */}
        <div className="absolute inset-0 bg-pink-100 bg-opacity-40"></div>
        
        {/* Floating decorative elements */}
        <div className="absolute top-20 left-10 w-4 h-4 bg-white/20 rounded-full animate-float delay-300"></div>
        <div className="absolute top-40 right-20 w-6 h-6 bg-white/15 rounded-full animate-float-reverse delay-700"></div>
        <div className="absolute bottom-32 left-20 w-3 h-3 bg-white/25 rounded-full animate-float delay-1000"></div>
        <div className="absolute bottom-20 right-32 w-5 h-5 bg-white/20 rounded-full animate-float-reverse delay-500"></div>
      </div>
      
      {/* Content Overlay */}
      <div className="relative z-10 flex items-center justify-center h-full">
        <div className="text-center max-w-4xl mx-auto px-6 animate-fade-in-up">
          <div className="relative">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-black mb-6 font-serif leading-tight animate-slide-in-scale">
              Forever Young<br />
              <span className="text-4xl md:text-5xl lg:text-6xl animate-bounce-in delay-500">Laser Clinic & Spa</span>
            </h1>
            {/* Sparkle effects around title */}
            <div className="absolute -top-4 -left-4 w-2 h-2 bg-pink-300 rounded-full animate-sparkle delay-1000"></div>
            <div className="absolute top-8 -right-8 w-3 h-3 bg-pink-200 rounded-full animate-sparkle delay-1200"></div>
            <div className="absolute -bottom-2 left-1/4 w-2 h-2 bg-pink-300 rounded-full animate-sparkle delay-1500"></div>
          </div>
          
          <p className="text-xl md:text-2xl text-black mb-4 font-light animate-fade-in delay-300 hover-glow">
            Calgary's Premier Beauty & Wellness Destination
          </p>
          <p className="text-lg md:text-xl text-gray-800 mb-8 max-w-2xl mx-auto animate-slide-right delay-500">
            Experience the confidence of radiant skin and professional care
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-fade-in delay-700">
            <Button 
              size="lg" 
              href="tel:4034548778"
              className="text-lg px-10 py-4 transform hover:scale-110 transition-all duration-300 animate-heartbeat hover-glow"
            >
              <i className="ri-phone-line mr-2 animate-wiggle"></i>
              Book Now - (403) 454-8778
            </Button>
            <Button 
              variant="secondary" 
              size="lg"
              onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
              className="text-lg px-10 py-4 transform hover:scale-110 transition-all duration-300 interactive-card"
            >
              <i className="ri-arrow-down-line mr-2 animate-bounce-subtle"></i>
              View Services
            </Button>
          </div>
        </div>
      </div>
      
      {/* Animated scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce-subtle">
        <div className="w-6 h-10 border-2 border-black/30 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-black/40 rounded-full mt-2 animate-pulse-dot"></div>
        </div>
      </div>
    </section>
  );
}
